import { useAppStore } from '../appStore'
import { PersistedItem } from './persistenceSlice.types'

export const usePersisted = <T>(
  inputPersistedItem: Partial<PersistedItem<T>> & Pick<PersistedItem<T>, 'key'>,
) => {
  const { persistedItem, persist } = useAppStore(store => {
    const foundItem = store.persistence.getItem(inputPersistedItem.key)

    if (
      !foundItem &&
      (!inputPersistedItem.until || !inputPersistedItem.where)
    ) {
      throw new Error(
        `No persisted item found and no until or where provided ${inputPersistedItem.key}`,
      )
    }

    return {
      persistedItem: foundItem,
      persist: store.persistence.persist,
    }
  })

  const itemWithFallback = persistedItem ?? inputPersistedItem

  return [
    itemWithFallback.value as T,
    (value: T) => {
      return persist({
        ...inputPersistedItem,
        ...persistedItem,
        value,
      } as any)
    },
  ] as const
}
